import * as network from './network';

const getOrderAccountingData = (params) => {
  return network.post(`order/account`, params, true);
};

export default {
  getOrderAccountingData,
};
